module.exports = __webpack_public_path__ + "media/svg/anos_finais-e374799b.svg";